@if (condition) {
  <div class="order-reference-editor" [formGroup]="detailsFormGroup">
    <sc-flex vertical stretchContent>
      <sc-checkbox-field formControlName="train" labelDictionaryKey="tmc-yard.entity.transport.transport-scope.TRAIN"></sc-checkbox-field>
      <sc-checkbox-field formControlName="trailer" labelDictionaryKey="tmc-yard.entity.transport.transport-scope.TRAILER"></sc-checkbox-field>
      <sc-checkbox-field formControlName="swapTrailer" labelDictionaryKey="tmc-yard.entity.transport.transport-scope.SWAP_TRAILER"></sc-checkbox-field>
    </sc-flex>
  </div>
}
